import { signInWithRedirect } from "@aws-amplify/auth";
import { clog } from "../logs/clog";

export function redirectAuth() {
  const urlPath = window.location.pathname;
  const pathSegments = urlPath.split("/");
  const partnerPath = pathSegments.length > 1 ? pathSegments[1] : "";
  clog("partnerPath", partnerPath);

  if (partnerPath !== "") {
    window.location.replace(`/${partnerPath}`); // Redirect to partner-specific login
    return;
  }

  signInWithRedirect();
  return;
}
